<template>
    <div class="appoint-cont">
        <el-form label-position="right" :rules="rules" label-width="110px" ref="appointForm" :model="appointData">
            <el-form-item label="预约配送时间" :required="true">
                <div class="row-item">
                    <el-form-item prop="appointmentTime" :rules="[
                        { required: true, message: '请选择配送日期', trigger: 'change' }
                    ]">
                        <el-date-picker v-model="appointData.appointmentTime" class="appoint-date"
                            value-format="yyyy-MM-dd" placeholder="预约配送日期" type="date"
                            :picker-options="pickerOptions" :clearable="false" @change="val=>changeVal(val,'appointmentTime')"
                        ></el-date-picker>
                    </el-form-item>
                    <el-form-item prop="appointmentTimeSlot" class="row-item-ml" :rules="[
                        { required: isJzp || integrateFlag, message: '请选择预约配送时间', trigger: 'change' }
                    ]">
                        <el-select v-model="appointData.appointmentTimeSlot" placeholder="预约配送时间" clearable
                            @change="changeVal"
                            @visible-change="visiblChange">
                                <el-option v-for="item in timeSlotOptions" :key="item.value" :value="item.value" :label="item.label" :disabled="delieveryTimeSlotDisabled(item)"></el-option>
                        </el-select>
                    </el-form-item>
                </div>
            </el-form-item>
            <el-form-item label="改约原因" :rules="[
                        { required: requiredAppointReason, message: '请选择改约原因', trigger: 'change' }
                    ]" prop="appointmentChangeFirstReasonType">
                <div class="flex-box">
                    <el-cascader clearable class="appoint-reason"
                        v-model="appointData.appointReasons"
                        :options="appointReasonOptions"
                        @change="changeAppointReasons">
                    </el-cascader>
                    <div v-if="showRollbackBack" class="rollback-checkbox">
                        <el-tooltip  effect="dark" content="勾选后将按客户原因且超7天回滚上游系统" placement="top-start">
                            <el-checkbox v-model="appointData.rollBack" @change="rollbackTips">是否回滚</el-checkbox>
                        </el-tooltip>
                    </div>
                </div>
            </el-form-item>
            <el-form-item label="预约异常" prop="appointmentExceptionType">
                <selects :mValue="appointData.appointmentExceptionType"
                    :optionNum="'CAINIAO_WMS_ERROR'"
                    :prop="'appointmentExceptionType'"
                    @getSelectValue="getSelectValue"
                >
                </selects>
            </el-form-item>
            <el-form-item label="备注" prop="remark" :rules="[{ required: remarkFlag, message: '请填写备注', trigger: 'change' }]" class="task-appoint-form-item">
                <el-input type="text" v-model="appointData.remark" clearable maxlength="500" />
            </el-form-item>
            <el-form-item label="附件" prop="propertiesList"
            :rules="[{ required: propertiesList, message: '请上传附件', trigger: 'change' }]">
                 <dragAndCopyUpload
                    ref="dragAndCopyUpload"
                    :drag="true"
                    :type="'icon'"
                    :multiple="true"
                    :maxSize="100"
                    :compressImage="true"
                    :showFileList="false"
                    :propertiesList="appointData.propertiesList"
                />
            </el-form-item>
            <el-form-item v-if="isB2cZpFlag" label="" prop="provideHomeDelivery" class="task-appoint-form-item">
                 <el-checkbox v-model="appointData.provideHomeDelivery">上楼</el-checkbox>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import dayjs from 'dayjs';
import _ from 'lodash';
import { dictWithUrl } from '@/components/lots/api.js';
import selects from '@/components/lots/otpSelect';
import orderDataDict from '../../../../../utils/orderDataDict';
import dragAndCopyUpload from '../components/dragAndCopyUpload.vue';

const { CUSTOMER_REASON } = orderDataDict.APPOINT_REASON;
const { ORDER_STATUS } = orderDataDict;

const defaultForm = {
    requireInstallType: '', // 送装需求
    appointmentTime: '', // 预约配送日期
    appointmentTimeSlot: '', // 预约配送时间段
    appointmentInstallTime: '',
    appointmentInstallTimeSlot: '',
    appointmentChangeFirstReasonType: '', // 一级原因编码
    appointmentChangeFirstReasonValue: '', // 一级原因
    appointmentChangeSecondReasonType: '', // 二级原因编码
    appointmentChangeSecondReasonValue: '', // 二级原因编码
    appointmentExceptionType: '', // 预约异常类型
    appointmentExceptionValue: '', // 预约异常名称
    remark: '',
    provideHomeDelivery: false,
    intervieweeName: '',
    intervieweeTel: '',
    sendMessage: false,
    appointReasons: [],
    rollBack: false,
    operateSystem: 'TMS',// 操作系统
    propertiesList: []
};
export default {
    components: { selects, dragAndCopyUpload },
    props: {
        rowsData: {
            type: Array,
            default() {
                return [];
            }
        },
        selectChangeData: {
            type: Array,
            default() {
                return [];
            }
        },
        selectChangeGroupData: {
            type: Array,
            default() {
                return [];
            }
        },
        tableGroupData: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        const validateRevisiterInfoRules = (rule, value, callback) => {
            const reg = /^([0-9]|\-)+$/;
            if (this.showrevisiterInfo(this.appointData.appointmentChangeSecondReasonType)) {
                if (!value) {
                    callback(new Error('请输入被回访人电话'));
                } else if (!reg.test(value)) {
                    callback(new Error('请输入正确的电话'));
                } else if (value.length < 11 || value.length > 12) {
                    callback(new Error('不少于11位，不多于12位'));
                } else {
                    callback();
                }
            } else {
                callback();
            }
        };
        return {
            tableData:[],
            appointReasonOptions: [],
            appointData: _.cloneDeep(defaultForm),
            rules: {},
            revisiterInfoRules: [
                { validator: validateRevisiterInfoRules, trigger: 'blur' }
            ],
            pickerOptions: {
                disabledDate: time => {
                    return this.resetPickerOptions(time);
                }
            },
            nextDate: 12, // 时间间隔天数
            timeSlotOptions: [],
            timeOptionsGroup: {},
            currentDate: dayjs().format('YYYY-MM-DD'),
            primaryReason: {}, // 一级原因字典
            secondAppointReasons: {},// 二级原因字典
            secondNewAppointReasons: {},// 退货入库|拒收入库单二级原因字典
            dict:''
        };
    },
    watch: {
        'appointData.appointmentExceptionType'(val) {
            if (val) {
                this.$refs.appointForm.clearValidate();
            }
        },
        selectChangeData: {
            handler (newVal, oldVal) {
                this.tableData = newVal;
            },
            deep: true,
            immediate: true
        },
        selectChangeGroupData: {
            handler (newVal, oldVal) {
                if (this.OptionsVisableShow) {
                    this.appointData.appointmentTimeSlot = '';
                }
            },
            deep: true,
            immediate: true
        },
        tableGroupData: {
            handler (newVal, oldVal) {
                if (newVal.length && newVal.some(v => v.provideHomeDelivery)) {
                    this.appointData.provideHomeDelivery = true;
                } else {
                    this.appointData.provideHomeDelivery = false;
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        visiblChange (val) {
           this.timeSlotOptions = [];

            if (val && this.integrateFlag) {
                this.getTimeSlotOptions(this.timeOptionsGroup.APPOINT_TIME_INTEGRATE);
                return;
            }

            // 有精准配和非精准配订单时
            if (val && !this.selectChangeGroupData.length && this.tableGroupData.some(i => i.isJzpFlag === '是') && this.tableGroupData.some(i => i.isJzpFlag === '否')) {
                this.$message.warning('请先勾选订单');
            } else if (val && this.selectChangeGroupData.length && this.tableGroupData.some(i => i.isJzpFlag === '是') && this.tableGroupData.some(i => i.isJzpFlag === '否')) {
                if (val && this.selectChangeGroupData.some(i => i.isJzpFlag === '是') && this.selectChangeGroupData.some(i => i.isJzpFlag === '否')) {
                    this.$message.warning('精准配送单不能和非精准配送单一起预约');
                } else if (val && this.selectChangeGroupData.length && this.selectChangeGroupData.every(i => i.isJzpFlag === '是')) {
                    // 有值且全部精准配
                    this.getTimeSlotOptions(this.timeOptionsGroup.APPOINT_TIME_EXCAT);
                } else if (val && this.selectChangeGroupData.length && this.selectChangeGroupData.every(i => i.isJzpFlag === '否')) {
                    this.getTimeSlotOptions(this.timeOptionsGroup.APPOINT_TIME_ZONE);
                }
            } else if (val && this.tableGroupData.some(i => i.isJzpFlag === '是')) {
                // 只有精准配
                this.getTimeSlotOptions(this.timeOptionsGroup.APPOINT_TIME_EXCAT);
            } else if (val && this.tableGroupData.some(i => i.isJzpFlag === '否')) {
                // 只有非精准配
                this.getTimeSlotOptions(this.timeOptionsGroup.APPOINT_TIME_ZONE);
            }
        },
        async getAppointReason() {
            const primaryReasonRes = await dictWithUrl('OTP_CHANGE_RESERVATION_TYPE,OTP_SYS_TMS_MARK_SH,OTP_SYS_TMS_MARK_TH,APPOINT_TIME_ZONE,APPOINT_TIME_EXCAT,APPOINT_TIME_INTEGRATE');
            if (primaryReasonRes) {
                this.primaryReason = _.get(primaryReasonRes, 'data.OTP_CHANGE_RESERVATION_TYPE', {});
                this.secondAppointReasons = _.get(primaryReasonRes, 'data.OTP_SYS_TMS_MARK_SH', {});
                this.secondNewAppointReasons = _.get(primaryReasonRes, 'data.OTP_SYS_TMS_MARK_TH', {});
                const reasonType = this.isRiOrRri ? this.secondNewAppointReasons : this.secondAppointReasons;
                Object.entries(this.primaryReason).forEach(one => {
                    this.appointReasonOptions.push(
                        {
                            value: one[0],
                            label: one[1],
                            children: []
                        }
                    );
                });
                this.appointReasonOptions.forEach(f => {
                    Object.entries(reasonType).forEach(item => {
                        if (item[0] && item[0].split('_')[0] === f.value) {
                            f.children.push(
                                {
                                    value: item[0],
                                    label: item[1]
                                }
                            );
                        }
                    });
                });
                Object.assign(this.timeOptionsGroup, primaryReasonRes.data);
                const timeSlot = _.get(primaryReasonRes, 'data.APPOINT_TIME_ZONE', {});
                this.getTimeSlotOptions(timeSlot);
            }
        },
        getTimeSlotOptions(timeSlot) {
            const timeSlotOptionsArr = [];
            this.timeSlotOptions = [];
            Object.entries(timeSlot).forEach(item => {
                timeSlotOptionsArr.push({
                    value: item[0],
                    label: item[1]
                });
            });
            const timeSlotOptionsArrVal = timeSlotOptionsArr.map(item => item.value).sort();
            timeSlotOptionsArrVal.forEach(item => {
                Object.entries(timeSlot).forEach(t => {
                    if (item === t[0]) {
                        this.timeSlotOptions.push({
                            value: t[0],
                            label: t[1]
                        });
                    }
                });
            });
        },
        initInstallTimeData(data) {
            const appointData = this.appointData;
            if (appointData.requireInstallType === 'DELIVERYONLY') {
                appointData.appointmentInstallTime = appointData.appointmentInstallTimeSlot = '';
            } else if (appointData.requireInstallType === 'INTEGRATE') {
                appointData.appointmentInstallTime = appointData.appointmentTime;
                appointData.appointmentInstallTimeSlot = appointData.appointmentTimeSlot;
            }
        },
        getSelectValue(data, label) {
            this.appointData = { ...this.appointData, ...data, appointmentExceptionValue: label };
            this.initInstallTimeData();
        },
        changeVal(date,formName) {
            // 项目分类为门店退货XB_SHOP_RI,选择日期重新清空时间避免时间限制不生效
            if (this.rowsData.length &&this.rowsData[0].projectClassify && this.rowsData[0].projectClassify === 'XB_SHOP_RI' &&formName === 'appointmentTime') {
                this.appointData.appointmentTimeSlot = '';
            }
            this.initInstallTimeData();
        },
        changeAppointReasons (data) {
            this.appointData.appointmentChangeFirstReasonType = data[0] || '';
            this.appointData.appointmentChangeFirstReasonValue = this.primaryReason[data[0]];
            this.appointData.appointmentChangeSecondReasonType = data[1] || '';
            this.appointData.appointmentChangeSecondReasonValue = this.isRiOrRri ? this.secondNewAppointReasons[data[1]] : this.secondAppointReasons[data[1]];
        },
        limitMes(appointData, tableData) {
            let msg = '';
            const { TUNED } = ORDER_STATUS;

            if (appointData.requireInstallType === 'DELIVERYFIRST') {
                const setAppointTime = appointData.appointmentTime + ' ' +
                    (appointData.appointmentTimeSlot ? appointData.appointmentTimeSlot.split('-')[0] : '23:59:59');
                const setInstallTime = appointData.appointmentInstallTime + ' ' +
                    (appointData.appointmentInstallTimeSlot ? appointData.appointmentInstallTimeSlot.split('-')[0] : '23:59:59');
                if (new Date(setInstallTime).getTime() - new Date(setAppointTime).getTime() < 0) {
                    msg = '预约安装时间不能小于配送时间！';
                }
            }
            const mustDispatchTaskList = tableData.filter(v => (v.stateSubsidiesFlag && v.sourceSystem === 'CAINIAO')).map(i => i.taskNo);
            if (this.dict.GB_LIMIT_TIME.limitTime && mustDispatchTaskList.length && (new Date(appointData.appointmentTime).getTime() - new Date(this.dict.GB_LIMIT_TIME.limitTime).getTime() > 0)) {
                msg = `国家补贴订单${mustDispatchTaskList.join(',')}不能预约${this.dict.GB_LIMIT_TIME.limitTime}日之后的日期！`;
            }
            if (appointData.rollBack && !msg) {
                tableData.forEach(item => {
                    if (item.orderStatus >= TUNED) {
                        msg = '存在已调车任务，不允许操作回滚，请取消调车';
                    }
                });
            }
            return msg;
        },
        reset() {
            this.ofcFailList = [];
            this.appointData = _.cloneDeep(defaultForm);
        },
        checkSave() {
            this.$refs.appointForm.validate((valid) => {
                if (valid) {
                    const limitMessage = this.limitMes(this.appointData, this.tableData);
                    if (limitMessage) {
                        this.$emit('checkResult');
                        return this.$message.warning(limitMessage);
                    };
                    const taskNoList = this.tableData.map(row => row.taskNo);
                    const params = {
                        taskNoList,
                        ...this.appointData,
                        sendMessage: this.appointData.sendMessage ? 1 : 0
                    };
                    if (['20_10', '20_18', '20_19', '20_20'].includes(params.appointmentChangeSecondReasonType) || params.appointmentChangeFirstReasonType === '30') {
                        params.operateSystem = 'TMS-Auto';
                    } else {
                        params.operateSystem = 'TMS';
                    }
                    this.$emit('checkResult', params);
                } else {
                    this.$emit('checkResult');
                }
            });
        },
        setAppointTimeFunc(time) {
            const that = this;
            this.appointData.appointmentTime = time;
            // 监听下拉数据是否有数据
            this.$watch(
                function() {
                    return that.timeSlotOptions;
                },
                function(newVal, oldVal) {
                    if (newVal.length) {
                        that.appointData.appointmentTimeSlot = newVal[newVal.length - 1].value;
                    }
                }
            );
        },
        rollbackTips(val) {
            if (val) this.$message.error('谨慎操作！非客户原因进行该操作，将按红线处理。');
        },
        resetPickerOptions (time) {
            // 项目分类为门店退货XB_SHOP_RI
            if (this.rowsData[0].projectClassify && this.rowsData[0].projectClassify === 'XB_SHOP_RI') {
                // 时间段为0-14时间隔12天
                if (dayjs(this.rowsData[0].orderTime).hour() < 14 && dayjs(this.rowsData[0].orderTime).hour() >= 0) {
                    this.nextDate = 12;
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 || time.getTime() > new Date(this.rowsData[0].orderTime).getTime() + 24 * 60 * 60 * 1000 * 12;
                }
                // 时间段为14-23时间隔13天
                if (dayjs(this.rowsData[0].orderTime).hour() >= 14 && dayjs(this.rowsData[0].orderTime).hour() <= 23) {
                    this.nextDate = 13;
                    return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 || time.getTime() > new Date(this.rowsData[0].orderTime).getTime() + 24 * 60 * 60 * 1000 * 13;
                }
            }
            if (this.lastPreAppointmentTime.length && this.integrateFlag) {
                return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 || dayjs(time).isBefore(this.lastPreAppointmentTime[0], 'day'); // 禁用前置最晚时间之前的所有日期
            }

            return time.getTime() < Date.now() - 24 * 60 * 60 * 1000;
        },
    },
    computed: {
        OptionsVisableShow () {
            // 预约时间更新标识，当数据全部非精准配 或 全部精准配。
            if (this.tableGroupData.every(i => i.isJzpFlag === '否')  || (this.selectChangeGroupData.length && (this.selectChangeGroupData.every(i => i.isJzpFlag === '是') || this.selectChangeGroupData.every(i => i.isJzpFlag === '否')))) {
                return false;
            }
            return true;
        },
        delieveryTimeSlotDisabled() {
            return function (item) {
                const appointmentTime = this.appointData.appointmentTime;
                // 项目分类为门店退货XB_SHOP_RI
                if (this.rowsData.length &&this.rowsData[0].projectClassify && this.rowsData[0].projectClassify === 'XB_SHOP_RI') {
                    const orderTime = this.rowsData[0].orderTime ? this.rowsData[0].orderTime.split(' ') : [];
                    // 选择预约日期等于创建订单日期时
                    if (dayjs(appointmentTime).valueOf() === dayjs(orderTime[0]).valueOf()) {
                        if (item.value && item.value.split('-')[1].split(':')[0] < dayjs(this.rowsData[0].orderTime).hour()) return true;
                        return false;
                    }
                    // 选择允许的最大可预约日期时
                    if (dayjs(appointmentTime).valueOf() === dayjs(orderTime[0]).add(this.nextDate, 'day').valueOf()) {
                        if (item.value && item.value.split('-')[1].split(':')[0] > dayjs(this.rowsData[0].orderTime).hour() && dayjs(this.rowsData[0].orderTime).hour() >= 14) return true;
                        return false;
                    }
                } else {
                    if (appointmentTime && dayjs(appointmentTime).format('YYYY-MM-DD') === this.currentDate) {
                        if (item.value && item.value.split('-')[1].split(':')[0] < dayjs().hour()) return true;
                        return false;
                    }
                }
            };
        },
        timeSlotOptionsDisabled() {
            return function(item) {
                const appointmentInstallTime = this.appointData.appointmentInstallTime;
                if (appointmentInstallTime && dayjs(appointmentInstallTime).format('YYYY-MM-DD') === this.currentDate) {
                    if (item.value && item.value.split('-')[1].split(':')[0] < dayjs().hour()) return true;
                    return false;
                }
            };
        },
        showrevisiterInfo() {
            return function(appointmentChangeSecondReasonType) {
                if (appointmentChangeSecondReasonType && appointmentChangeSecondReasonType.split('_')[0] === CUSTOMER_REASON && this.rowData.businessMode === 'B2B') {
                    return true;
                }
                return false;
            };
        },
        showRollbackBack() {
            return this.appointData.appointmentChangeFirstReasonType === CUSTOMER_REASON;
        },
        // 【预约配送时间】 与所有【时效考核时间】都一致时，改约原因不强控，否则必填  by  曾泓铄
        requiredAppointReason() {
            const samList = this.tableData.filter(item => {
                return dayjs(item.examineTime).format('YYYY-MM-DD') === this.appointData.appointmentTime;
            });
            return !(this.appointData.appointmentExceptionType || samList.length === this.tableData.length);
        },
        propertiesList() { // 联系不上客户、客户下单错误、非直通宝拨号预约附件必须上传
            return (['20_08', '20_10', '20_18'].includes(this.appointData.appointmentChangeSecondReasonType) || this.appointData.appointmentChangeFirstReasonType === '30');
        },
        remarkFlag () {
            return ['20_43', '30_4'].includes(this.appointData.appointmentChangeSecondReasonType);
        },
        isRiOrRri () { // 订单类型=退货入库单或拒收入库单或上门取件退货单
            return this.tableData.some(v => {
                return v.orderType === 'RI' || v.orderType === 'RRI' || v.orderType === 'DPRI';
            });

        },
        isJzp () {//判断是否包含精准配送订单
            return this.tableData.some(v => v.isJzp === 'Y');
        },
        lastPreAppointmentTime () { // 选中单子最晚的前置预约时间
            return this.tableData.filter(v => v.preAppointmentTime).map(v => v.preAppointmentTime).sort((a, b) => dayjs(b).valueOf() - dayjs(a).valueOf());
        },
        integrateFlag() {
            return this.selectChangeGroupData.some(i => i.appointmentTypeExt === 'INTEGRATE');
        },
        isB2cZpFlag  () { // 判断是否2C直配订单且非上楼的订单
            return this.tableGroupData.some(v => v.enableProvideHomeDelivery);
        }
    },
    async mounted() {
        this.getAppointReason();
        const res = await dictWithUrl('GB_LIMIT_TIME');
        if (+res.code === 0) {
            this.dict = res.data || '';
        }
    }
};
</script>
<style lang="less">
.appoint-cont {
    .row-item {
        display: flex;
    }
    .appoint-reason {
        width: 100%;
    }
    .row-item-ml {
        margin-left: 10px;
    }
    .appoint-date {
        width: 100%;
    }
    .task-appoint-form-item {
        padding-bottom: 10px;
    }
    .flex-box {
        display: flex;
        align-items: center;
        .appoint-reason {
            flex: 1;
        }
    }
    .rollback-checkbox {
        margin-left: 10px;
    }
}
</style>
